import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;
const API_KEY = 'BT001-REACH-TRCKS';

export async function sendSms({ to, message, apiKey = API_KEY }) {
  const payload = {
    To: to,
    Message: message,
  };
  try {
    const response = await axios.post(`${API_BASE}/sms/send`, payload, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'accept': '*/*',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to send SMS');
  }
}

export async function sendBulkSms({ to, message, apiKey = API_KEY }) {
  const payload = {
    To: to,
    Message: message,
  };
  try {
    const response = await axios.post(`${API_BASE}/sms/send-bulk`, payload, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'accept': '*/*',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to send bulk SMS');
  }
}

export const getAllPhoneNumbers = async ({
  pageNumber = 1,
  pageSize = 10,
  searchTerm = '',
  sortBy = 'createdAt',
  sortDescending = true,
  phoneNumbers,
  fullName,
  metadata,
  status,
  blockReason,
  createdFrom,
  createdTo
} = {}) => {
  const queryParams = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortDescending: sortDescending.toString()
  });

  if (searchTerm) queryParams.append('searchTerm', searchTerm);
  if (phoneNumbers) queryParams.append('phoneNumbers', phoneNumbers);
  if (fullName) queryParams.append('fullName', fullName);
  if (metadata) queryParams.append('metadata', metadata);
  if (status) queryParams.append('status', status);
  if (blockReason) queryParams.append('blockReason', blockReason);
  if (createdFrom) queryParams.append('createdFrom', createdFrom + 'T00:00:00');
  if (createdTo) queryParams.append('createdTo', createdTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/sms/phonenumbers/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch phone numbers');
  }

  return response.json();
};

export const getAllSmsMessages = async ({
  pageNumber = 1,
  pageSize = 10,
  searchTerm = '',
  sortBy = 'createdAt',
  sortDescending = true,
  smsTemplateId,
  recipientNumbers,
  senderNumbers,
  status,
  messageBody,
  dateFrom,
  dateTo
} = {}) => {
  const queryParams = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortDescending: sortDescending.toString()
  });

  if (searchTerm) queryParams.append('searchTerm', searchTerm);
  if (smsTemplateId) queryParams.append('smsTemplateId', smsTemplateId);
  if (recipientNumbers) queryParams.append('recipientNumbers', recipientNumbers);
  if (senderNumbers) queryParams.append('senderNumbers', senderNumbers);
  if (status) queryParams.append('status', status);
  if (messageBody) queryParams.append('messageBody', messageBody);
  if (dateFrom) queryParams.append('dateFrom', dateFrom + 'T00:00:00');
  if (dateTo) queryParams.append('dateTo', dateTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/sms/messages/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch SMS messages');
  }

  return response.json();
};


export async function getSmsStats(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/request-analytics/stats/sms`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': apiKey
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch SMS stats');
  }
}

export async function getSmsHistoryBySmsId(smsId) {
  try {
    const response = await axios.get(`${API_BASE}/sms/${smsId}/history`, {
      headers: {
        'accept': 'application/json, text/plain, */*',
        'X-API-Key': API_KEY
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch SMS history');
  }
}

export async function updatePhoneNumberBlockStatus(data, apiKey = API_KEY) {
  try {
    const response = await axios.put(`${API_BASE}/sms/update-block-status`, data, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to update phone number block status');
  }
}

export const updatePhoneNumber = async (updateData) => {
  try {
    const response = await fetch(`${API_BASE}/sms/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': API_KEY
      },
      body: JSON.stringify(updateData)
    });

    if (!response.ok) {
      throw new Error('Failed to update phone number');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating phone number:', error);
    throw error;
  }
};

export const createPhoneNumber = async (phoneNumberData) => {
  try {
    const response = await fetch(`${API_BASE}/sms/phonenumbers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': API_KEY
      },
      body: JSON.stringify(phoneNumberData)
    });

    if (!response.ok) {
      throw new Error('Failed to create phone number');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating phone number:', error);
    throw error;
  }
};

export const createBulkPhoneNumbers = async (phoneNumbersData) => {
  try {
    const response = await fetch(`${API_BASE}/sms/phonenumbers/bulk`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': API_KEY
      },
      body: JSON.stringify(phoneNumbersData)
    });

    if (!response.ok) {
      throw new Error('Failed to create phone numbers');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating phone numbers:', error);
    throw error;
  }
}; 

export const exportPhoneNumbers = async (params) => {
  const queryParams = new URLSearchParams();

  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortDescending !== undefined) queryParams.append('sortDescending', params.sortDescending.toString());
  if (params.exportTo) queryParams.append('exportTo', params.exportTo);
  if (params.phoneNumbers) queryParams.append('phoneNumbers', params.phoneNumbers);
  if (params.fullName) queryParams.append('fullName', params.fullName);
  if (params.metadata) queryParams.append('metadata', params.metadata);
  if (params.status) queryParams.append('status', params.status);
  if (params.blockReason) queryParams.append('blockReason', params.blockReason);
  if (params.createdFrom) queryParams.append('createdFrom', params.createdFrom + 'T00:00:00');
  if (params.createdTo) queryParams.append('createdTo', params.createdTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/sms/phonenumbers/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to export phone numbers');
  }

  const blob = await response.blob();
  return { data: blob };
};